import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface CartDetail {
  mobileNo: string;
  appId: string;
  prod: string;
  prodDesc: string;
  appLink: string | null;
  img: string | null;
  channel: string;
  prodProps: string;
  resumeFlag: boolean;
  appVersion: string | null;
  nudgeText: string | null;
  recordTime: number;
  schemeId: string | null;
  id: string;
  partnerCode: string | null;
  associateCode: string | null;
  loanApplicationNo: string | null;
  customerName: string | null;
  pan: string | null;
  branch: string | null;
  state: string | null;
  companyName: string | null;
  applicationDateTime: string | null;
  variant: string | null;
  emi: string | null;
  roi: string | null;
  amt: string | null;
  tenure: string | null;
  genrateAppId: string | null;
}

interface Offer {
  mobile: string;
  id: string;
  icorsOfferType: string;
  icorsDate: string | null;
  systemModstamp: string | null;
  amount: string;
  flag: string;
  poName: string;
  pinCode: string | null;
  prospectId: string | null;
  product: string | null;
  processSegmentation: string | null;
  offerIrr: string | null;
  paEmi: string | null;
  pqEmi: string | null;
  offerBatchId: string | null;
  customerBatchId: string | null;
  emailId: string;
  email: string | null;
  offerId: string;
  customerId: string | null;
  emicardNumber: string | null;
  cardGroup: string | null;
  bvCode: string | null;
  loanType: string | null;
  bt: string | null;
  displayName: string;
  twoYearPremium: string | null;
  threeYearPremium: string | null;
  oneYearPremium: string | null;
  partnerName: string | null;
  offerStatus: string | null;
  createdDate: string | null;
  dealId: string | null;
  lan: string | null;
  emiAmount: string | null;
  nextEmiDueDate: string | null;
  productCategory: string | null;
  model: string | null;
  manufacturer: string | null;
  invoiceNo: string | null;
  invoiceDate: string | null;
  invoiceAmount: string | null;
  serialNo: string | null;
  insuranceProductSelection: string | null;
  expiryDate: string | null;
  offerDisplayMedium: string | null;
  customerName: string;
  offerAmt: string | null;
  offerType: string | null;
  schemeCode: string | null;
  tenure: string | null;
  processingFee: string | null;
  roi: string | null;
  offerRoi: string | null;
  emi: string;
  productId: string | null;
  supplierId: string | null;
  offerPriority: string | null;
  ivrFlag: string | null;
  displayPriority: number;
  maxTenure: string | null;
  irr: string | null;
  maxEmiLimitPerMonth: string | null;
  stampDuty: string | null;
  personalEmailAddress: string | null;
  dateOfBirth: string;
  panNumber: string | null;
  bankName: string | null;
  bankAccountNumber: string | null;
  employerName: string | null;
  officialEmailId: string | null;
  officeCity: string | null;
  officePinCode: string | null;
  address1: string | null;
  address2: string | null;
  address3: string | null;
  city: string | null;
  state: string | null;
  employmentType: string | null;
  ffrChargesForPltb: string | null;
  cppChargesForPltb: string | null;
  customerId1: string | null;
  cardSubType: string | null;
  cmsCardType: string | null;
  custRiskClassification: string | null;
  customerBranchId: string | null;
  sourceDealer: string | null;
  residenceAddress1: string | null;
  dob: string | null;
  cibilScore: string | null;
  cibilDate: string | null;
  empName: string | null;
  gender: string | null;
  vcNum: string | null;
  sourceId: string | null;
  oldSourceId: string | null;
  sourceName: string | null;
  orAdditionalFilter: string | null;
  andAdditionalFilter: string | null;
  preApprovedAmount: string | null;
  preQualifiedAmount: string | null;
  grId: string | null;
  preferredLanguage: string | null;
  currentResidencePincode: string | null;
  currentResidenceCity: string | null;
  currentResidenceState: string | null;
  offerValidity: string | null;
  offerDisposition: string | null;
  offerStage: string | null;
  riskHoldReason: string | null;
  offerProduct: string | null;
  sourcingBranch: string | null;
  businessHoldReason: string | null;
  pan: string | null;
  banner: string | null;
  cta: string | null;
  mainStatusCodeTc: string | null;
  pinCodeC: string;
  activeFlag: string;
  segment: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  panCardNumber: string;
  offerExpiryDate: string;
  lastLoanAmount: string | null;
  loanDisbursedDate: string | null;
  baseProduct: string;
  isCreditCardHolder: string;
  processSegmentationPltb: string | null;
  monthOfOffer: string | null;
  programType: string | null;
  financedAmount: string | null;
  sourceOfData: string | null;
  campaignLot: string | null;
  ownerId: string | null;
  noOfCreditCardsBureau: string | null;
  cibilNotes: string | null;
  companyCategory: string | null;
  fraudCustomersFlag: string | null;
  subProfession: string | null;
  maxLoanVariant: string | null;
  maxLoanTenor: string | null;
  origBus: string | null;
  interestCharge: string | null;
  fddTelebinding: string | null;
  productMake: string | null;
  emiCardLimit: string | null;
  emiCard: string | null;
  baseType: string | null;
  groupCode: string | null;
  dealerCode: string | null;
  custType: string | null;
  offerView: number;
  offerCall: number;
  offerMaxTenor: string | null;
  oemName: string | null;
  schemeName: string | null;
  schemeCategory: string | null;
  schemeType: string | null;
  comboRevampFlag: string | null;
  emiWaiver: string | null;
  walletStatus: string | null;
  status3in1App: string | null;
  upiStatus: string | null;
  cardSource: string | null;
  branch: string | null;
  bajajCoinsAmount: string | null;
  isRmsOffer: string | null;
  bajajCoinsCampaignName: string | null;
  isPromoCodeRequired: string | null;
  promoCode: string | null;
  offerAutoSelection: string | null;
  dealerContribution: string | null;
  opportunityName: string | null;
  offerTags: string | null;
  freebieValue: string | null;
  customerType: string;
  productPrice: string | null;
  oemId: string | null;
  oemCashbackAllowed: string | null;
  mobileNumber: string | null;
  voucherAmount: string | null;
  modelId: string | null;
  modelCode: string | null;
  interestedProduct: string | null;
  personalizedOfferText: string | null;
  offerName: string | null;
  channelFlag: string | null;
  offerFlag: string | null;
  startDate: string | null;
  endDate: string | null;
  minLoanAmount: string | null;
  maxLoanAmount: string | null;
  brand: string | null;
  assetCategoryId: string | null;
  skuId: string | null;
  tncSummary: string | null;
  detailedTncLink: string | null;
  chargeApplicationByDefault: string | null;
  cashback_byAmount: string | null;
  freeTextField: string | null;
  cashbackByPercentage: string | null;
  freebieName: string | null;
  type: string | null;
  promoVisibility: string | null;
  promoSequencing: string | null;
  primaryOfferText: string | null;
  secondaryOfferText: string | null;
  shortOfferText: string | null;
  shortTnc: string | null;
  idNum: string | null;
  marketplaceTagsBrand: string | null;
  marketplaceTagsProduct: string | null;
  marketplaceTagsPrice: string | null;
  rblApplicationRequired: string | null;
  sms: string | null;
  instaIdentifier: string | null;
  customerSegmentType: string | null;
  prodMastCode: string | null;
  prodCategoryCode: string | null;
  pocketProductCode: string | null;
  enquiryDate: string | null;
  enquirySource: string | null;
  programName: string | null;
  oldDisplayPriority: string | null;
  emiCardOfferType: string | null;
  hcLimit: string | null;
  hcOfferType: string | null;
  dbdate: string | null;
  creditProgramorsurrogate: string | null;
  custId: string | null;
  loanVariant: string | null;
  offerTenor: string | null;
  offerRoiAnnual: string | null;
  offerPf: string | null;
  profession: string | null;
  personalEmailId: string | null;
  existingLan: string | null;
  sourcingType: string;
  renewalDate: string | null;
  riskProgram: string | null;
  lookupType: string | null;
  offerText1: string | null;
  offerText2: string | null;
  offerText3: string | null;
  offerText4: string | null;
  offerText5: string | null;
  businessIdentifier: string | null;
  segmentList: string | null;
  exAssetCategory: string | null;
  exOemName: string | null;
  exModelCode: string | null;
  exSchemeName: string | null;
  oemChargeCode: string | null;
  oemChargeFlag: string | null;
  modelClassification: string | null;
  cardSourceType: string | null;
  offerText: string | null;
  integererestCharge: string | null;
  PQofferIrr: string | null;
}

export interface SegmentData {
  fees: string;
  cardcode: string;
  pricingcode: string;
  logo: string;
  cardtype: string;
  blkcode: string;
  cardCodeId: string;
  approvalPageFeature1: string;
  approvalPageFeature2: string;
  FirstYear_fees: string;
  Subsequent_year_fee_Waived: string;
  Subsequentyear_fee: string;
  Annual_fee: string;
  Priority__c: string;
}

interface SegmentResponse {
  segment: string;
  id: string;
  segment_data: SegmentData[];
}

export interface ICCDetails {
  cartDetails: CartDetail[];
  offerList: Offer[];
  segmentResponse: SegmentResponse;
}

export const getCCDetails = async (
  product: string,
  subProduct?: string
): Promise<IResponse<ICCDetails>> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<ICCDetails>({
      method: "POST",
      url: API_PATHS.ccDetails,
      data: {
        mobileNo,
        product,
        subProduct,
      },
    });

    return response;
  } catch (error) {
    // this can be replaced once new relic implemented
    console.error(error);
    throw error;
  }
};
